var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.825,
    height: 16.886,
    viewBox: "0 0 13.825 16.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.258 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58556",
    "data-name": "Path 58556",
    d: "M222.782,154.7a.384.384,0,0,0-.384.384v7.253a.384.384,0,1,0,.767,0v-7.253A.384.384,0,0,0,222.782,154.7Zm0,0",
    transform: "translate(-213.864 -148.766)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58557",
    "data-name": "Path 58557",
    d: "M104.782,154.7a.384.384,0,0,0-.384.384v7.253a.384.384,0,1,0,.767,0v-7.253A.384.384,0,0,0,104.782,154.7Zm0,0",
    transform: "translate(-100.392 -148.766)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58558",
    "data-name": "Path 58558",
    d: "M1.087,4.877v9.455a2.117,2.117,0,0,0,.563,1.46,1.89,1.89,0,0,0,1.371.593h7.26a1.889,1.889,0,0,0,1.371-.593,2.117,2.117,0,0,0,.563-1.46V4.877a1.466,1.466,0,0,0-.376-2.883H9.874v-.48A1.507,1.507,0,0,0,8.355,0H4.947a1.507,1.507,0,0,0-1.52,1.516v.48H1.463a1.466,1.466,0,0,0-.376,2.883Zm9.194,10.74H3.021a1.215,1.215,0,0,1-1.167-1.286V4.91h9.593v9.421a1.215,1.215,0,0,1-1.167,1.286ZM4.195,1.514A.739.739,0,0,1,4.947.766H8.355a.739.739,0,0,1,.752.748v.48H4.195ZM1.463,2.761H11.839a.691.691,0,1,1,0,1.381H1.463a.691.691,0,1,1,0-1.381Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58559",
    "data-name": "Path 58559",
    d: "M163.782,154.7a.384.384,0,0,0-.384.384v7.253a.384.384,0,1,0,.767,0v-7.253A.384.384,0,0,0,163.782,154.7Zm0,0",
    transform: "translate(-157.128 -148.766)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.092ebef6de0d5b32ac47470a59913909.svg";
export { ForwardRef as ReactComponent };